"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularLoaderControl = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@nextui-org/react");
function CircularLoaderControl(_a) {
    var size = _a.size;
    var sizeClasses = {
        xsmall: "w-4 h-4",
        small: "w-6 h-6",
        medium: "w-8 h-8",
        large: "w-10 h-10",
        xlarge: "w-20 h-20",
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-center items-center" }, { children: (0, jsx_runtime_1.jsx)(react_1.CircularProgress, { className: "".concat(sizeClasses[size]) }) })));
}
exports.CircularLoaderControl = CircularLoaderControl;
